import { ShareModalType } from '@DavisDigital/directives/modals/share-setting-modal';
import { Folder, FolderTypes, ContentModule, Lesson, Portfolio } from '@DavisDigital/interfaces';
FolderTypes.MySharedWithMePortfolio
export class ListingModalService {
	public constructor(private ModalService) {}

	private onShowBsModal() {
		$('body').addClass('show--lesson--modal--center');

        // TODO: this's showing quirky behaviour

		setTimeout(() => {
			if ($('body').hasClass('touch-devices-body') || navigator.userAgent.indexOf('Mac') > 0) {
				if ($(window).width() > 767) {
					$('.lessonModal .modal-body .mCustomScrollbar').height(
					    350
				// 		$(window).height() - ( $('.lessonModal .modal-dialog .modal-header').outerHeight() + $('.lessonModal .modal-footer').outerHeight() + 316 ) 	
					);

					// $('.lessonModal .modal-body .mCustomScrollbar').mCustomScrollbar(); // throwing mCustomScrollbar is not a function
					$('.lessonModal .modal-body').css('overflow', 'scroll');
				} else {
					$('.lessonModal .modal-body .mCustomScrollbar').height(
						$('.lessonModal .modal-body').outerHeight(),
					);
				}
			}
		}, 200);

		$('.lessonModal .nav-tabs')
			.find('a')
			.on('show.bs.tab', () => {
				setTimeout(() => {
					$('.lessonModal .modal-body .mCustomScrollbar').height(
						$('.lessonModal .tab-pane.show .modal-body').outerHeight(),
					);
				}, 1000);
			});

		$('.lessonModal .modal-dialog .modal-header .search-toggle').click((e) => {
			$('.lessonModal .modal-dialog .modal-header .modal__header__text .mobile--dropdown').toggleClass(
				'show',
			);

			if (
				$('.lessonModal .modal-dialog .modal-header .modal__header__text .mobile--dropdown').hasClass(
					'show',
				)
			) {
				$(this).find('.far').removeClass('fa-plus-square').addClass('fa-minus-square');
			} else {
				$(this).find('.far').removeClass('fa-minus-square').addClass('fa-plus-square');
			}
		});
	}

	private onHideBsModal() {
		$('.lessonModal').on('hide.bs.modal', function (e) {
			$('body').removeClass('show--lesson--modal--center');
		});
	}

	private onModalServiceCallback = (modal, callback?: Function) => {
		//it's a bootstrap element, use 'modal' to show it

		modal.element.modal('show');

		this.onShowBsModal();
		
		modal.close.then((result) => {
			this.onHideBsModal();
			
			modal.element.modal('hide');
			callback?.(result);
		});
	};

	public launchAddEditFolderModal = (
		folderType: FolderTypes,
		folderId?: string,
		folderName?: string,
		callback?: Function,
		sourcePage?: string,
	) => {
		this.ModalService.showModal({
			component: 'addEditFolderModal',
			bodyClass: 'angular-modal-service-active',
			bindings: {
				folderType: folderType,
				folderId: folderId,
				folderName: folderName,
				sourcePage: sourcePage,
			},
		}).then((modal) => {
			this.onModalServiceCallback(modal, callback);
		});
	};
	
	public launchVideoPlayerModal = (
		videoUrl:string,
		callback?: Function,
	) => {
		this.ModalService.showModal({
			component: 'videoPlayerModal',
			bodyClass: 'angular-modal-service-active',
			bindings: {
				videoUrl: videoUrl,
			},
		}).then((modal) => {
			this.onModalServiceCallback(modal, callback);
		});
	};

	/******* 
        Generic Modals for Lesson, Portfolio, Folder(Lesson and Portfolio) ] Entities 
    ********/

	/**
	 * Generic Sharng-SettingsModal for  [ Lesson, Portfolio, Folder(Lesson and Portfolio) ] entities
	 * @title,          title of the base oblect (the name)
	 * @baseObjectId,
	 * @type,           BaseObject type [lesson, portfolio, folder]
	 * @callback,
	 * @baseObject
	 * @shareWithClass boolean
	 */
	public launchShareSettingModal = (
		title: string,
		baseObjectId: string,
		type: ShareModalType,
		subType:string = "",
		callback?: Function,
		baseObject:any = {},
		shareWithClass:boolean = false
	) => {
		this.ModalService.showModal({
			component: 'shareSettingsModal',
			bodyClass: 'angular-modal-service-active',
			bindings: {
				title: title,
				baseObjectId: baseObjectId,
				type: type,
				subType: subType,
				baseObject: baseObject,
				shareWithClass: shareWithClass
			},
		}).then((modal) => {
			this.onModalServiceCallback(modal, callback);
		});
	};
	
	public launchImageCollectionShareModal = (
		baseObject:any = {},
		superUser: boolean = false,
		callback?: Function,
	) => {
		this.ModalService.showModal({
			component: 'imageCollectionShareModal',
			bodyClass: 'angular-modal-service-active',
			bindings: {
				baseObject: baseObject,
				superUser: superUser
			},
		}).then((modal) => {
			this.onModalServiceCallback(modal, callback);
		});
	};
	
	public launchPortfolioAdministerShareModal = (
		baseObject,
		callback?: Function,
	) => {
		this.ModalService.showModal({
			component: 'portfolioAdministerShareModal',
			bodyClass: 'angular-modal-service-active',
			bindings: {
				baseObject : baseObject,
			},
		}).then((modal) => {
			this.onModalServiceCallback(modal, callback);
		});
	};
	
	public launchImageCollectionCopyModal = (
		imageSet,
		callback?: Function,
	) => {
		this.ModalService.showModal({
			component: 'imageCollectionCopyModal',
			bodyClass: 'angular-modal-service-active',
			bindings: {
				imageSet: imageSet
			},
		}).then((modal) => {
			this.onModalServiceCallback(modal, callback);
		});
	};

	/**
	 * Generic Confirm-Delete Modal for  [ Lesson, Portfolio, Folder(Lesson and Portfolio) ] entities
	 * @title,          title of the base oblect (the name)
	 * @baseObjectId,
	 * @type,           BaseObject type [lesson, portfolio, folder]
	 * @callback,
	 * @folderType,     *required only when the base-object is Folder,
	 */
	public launchDeleteModal = (
		title: string,
		baseObjectId: string,
		type: ShareModalType,
		callback: (confirmDelete: boolean) => void,
		folderType?: 'portfolio' | 'lesson' | 'folder',
		unfollowShare: boolean = false,
	) => {
		this.ModalService.showModal({
			component: 'confirmDeleteModal',
			bodyClass: 'angular-modal-service-active',
			bindings: {
				title: title,
				baseObjectId: baseObjectId,
				type: type,
				folderType: folderType,
				closeCallback: callback,
				unfollowShare: unfollowShare,
			},
		}).then((modal) => {
			this.onModalServiceCallback(modal, callback);
		});
    }
    
    /**
	 * Generic Duplicate Modal for  [ Lesson, Portfolio ] entities
	 * 	TODO: duplicate-portfolio
	 * @param - ActionType - differentiate duplicate and save to my lesson actions
	 */
    public launchDuplicateModal = (
        lesson      ?: Lesson,
        portfolio   ?: Portfolio,
		callback    ?: Function,
		actionType: string = 'duplicate',
		accountType: string = ""
    ) => {
    	
        this.ModalService.showModal({
			component: 'duplicateModal', 
			bodyClass: 'angular-modal-service-active',
			bindings: {
			    lesson: lesson,
			    portfolio: portfolio,
			    actionType: actionType,
			    accountType: accountType
			},
		}).then((modal) => {
			this.onModalServiceCallback(modal, callback);
		});
	};
	
	
	/**
	 * Generic CopyContenemodule Modal for  [ Lesson, Portfolio ] entities
	 * TODO: copy-content for portfolio
	 */
	public launchCopyContentModal = (
	    contentModule: ContentModule, 
	    lesson?: Lesson, 
	    portfolio?: Portfolio, 
	    callback?: Function
	) => {
		this.ModalService.showModal({
			component: 'copyContentModal',
			bodyClass: 'angular-modal-service-active',
			bindings: {
				contentModule: contentModule,
				lesson: lesson,
				portfolio: portfolio
			},
		}).then((modal) => {
			this.onModalServiceCallback(modal, callback);
		});
	};

	
	
	public launchMoveModal = (title: string,
		baseObjectId: string,
		type: ShareModalType,
		folderType: string,
		callback?: Function) => {
		
		this.ModalService.showModal({
			component: 'moveContentModal',
			bodyClass: 'angular-modal-service-active',
			bindings: {
				title: title,
				baseObjectId: baseObjectId,
				folderType: folderType,
				type: type
			},
		}).then((modal) => {
			this.onModalServiceCallback(modal, callback);
		});
    }
    
    /**
     * Export Modal for  [ Lesson, Folders ] entities
     * @title,          title of the base oblect (the name)
     * @baseObjectId,   
     * @type,           BaseObject type [lesson, portfolio, folder]
     * @callback,       
    */
    public launchExportModal = (
    	folderType: string,
    	systemCode: FolderTypes,
	    title           : string,
		baseObjectId    : string,
		type            : ShareModalType,
		callback        ?: Function
    ) => {
        this.ModalService.showModal({
			component: 'exportContentModal',
			bodyClass: 'angular-modal-service-active',
			bindings: {
				folderType: folderType,
				systemCode: systemCode,
			    title: title,
			    baseObjectId: baseObjectId,
			    type: type
			}
		})
		.then( (modal) => {
			this.onModalServiceCallback(modal, callback);
		});
    }

	
	public launchArchiveModal = (title: string,
		baseObjectId: string,
		type: ShareModalType,
		archiveAction:boolean = true,
		callback?: Function) => {
		this.ModalService.showModal({
			component: 'archiveModal',
			bodyClass: 'angular-modal-service-active',
			bindings: {
				title: title,
				baseObjectId: baseObjectId,
				type: type,
				archiveAction: archiveAction
			},
		}).then((modal) => {
			this.onModalServiceCallback(modal, callback);
		});
	};
	
	public launchUserSummaryModal = (
        accounts:any,
        title: string,
        callback?: Function
    ) => {
        this.ModalService.showModal({
			component: 'userSummaryModal',
			bodyClass: 'angular-modal-service-active',
			bindings: {
			    accounts: accounts,
			    title: title,
			},
		}).then((modal) => {
			this.onModalServiceCallback(modal, callback);
		});
	};
	
	/**
	 * Method to launch cofirm modal for remove licenses
	 * @title,          title of the base oblect (the name)
	 * @baseObjectId,
	 * @type,           BaseObject type [lesson, portfolio, folder]
	 * @callback,
	 * @folderType,     *required only when the base-object is Folder,
	 */
	public launchDeleteLicenseModal = (
		username: string,
		licenses: any,
		callback: (confirmDelete: boolean) => void,
	) => {
		this.ModalService.showModal({
			component: 'confirmDeleteLicenseModal',
			bodyClass: 'angular-modal-service-active',
			bindings: {
				username: username,
				licenses: licenses,
				closeCallback: callback,
			},
		}).then((modal) => {
			this.onModalServiceCallback(modal, callback);
		});
    }
    
    public launchReassignLicenseModal = (
    	username: string,
    	accountID: string,
		licenses: any,
		callback: Function,
	) => {
		this.ModalService.showModal({
			component: 'licenseReassignModal',
			bodyClass: 'angular-modal-service-active',
			bindings: {
				username: username,
				accountId: accountID,
				licenses: licenses,
				closeCallback: callback,
			},
		}).then((modal) => {
			this.onModalServiceCallback(modal, callback);
		});
    }
	
	/**
	 * Generic Support-Ticket-Modal for submitting support tickets
	 * @callback,
	 */
	public launchSupportTicketModal = (callback: Function) => {
		this.ModalService.showModal({
			component: 'supportTicketModal',
			bodyClass: 'angular-modal-service-active',
			bindings: {},
		}).then((modal) => {
			this.onModalServiceCallback(modal, callback);
		});
	}
	
		/**
	 * Confirm-Delete Modal for Portfolio folder entities
	 * @title,          title of the base oblect (the name)
	 * @baseObjectId,
	 * @type,           BaseObject type [lesson, portfolio, folder]
	 * @callback,
	 * @folderType,     *required only when the base-object is Folder,
	 */
	public launchDeleteFolderModal = (
		title: string,
		baseObjectId: string,
		type: ShareModalType,
		callback: (confirmDelete: boolean) => void,
		folderType?: 'portfolio',
	) => {
		this.ModalService.showModal({
			component: 'confirmDeletePortfolioFolderModal',
			bodyClass: 'angular-modal-service-active',
			bindings: {
				title: title,
				baseObjectId: baseObjectId,
				type: type,
				folderType: folderType,
				closeCallback: callback,
			},
		}).then((modal) => {
			this.onModalServiceCallback(modal, callback);
		});
    }
}
